































































import { DiscountParams } from '@/store/interfaces/discount';
import { tCashbackParams } from '@/store/interfaces/cashback';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Participation',
  props: {
    model: {
      type: Object as PropType<DiscountParams | tCashbackParams>,
      required: true,
    },
  },
  data() {
    return {
      campaignParticipations: [
        {
          name: 'Plataforma',
          id: 'platform',
        },
        {
          name: '', // assign inside created function
          id: 'commerce',
        },
        {
          name: 'Compartido',
          id: 'shared',
        }
      ],
      scopeDiscounts: [
        {
          name: 'Todos',
          id: 'regular',
        },
        {
          name: 'Solo primera transacción',
          id: 'sign_up',
        }
      ],
    };
  },
  created() {
    this.campaignParticipations[1].name = this.$t('menu.commerce.singular.informal').toString();
  },
  computed: {
    syncedModel: {
      get(): DiscountParams | tCashbackParams {
        return this.model;
      },
      set(val: DiscountParams | tCashbackParams) {
        this.$emit('update:model', val);
      },
    },
    defaultSelected(): number {
      if (this.syncedModel.participation === 'platform') {
        return 1;
      } else if (this.syncedModel.participation === 'commerce') {
        return 2;
      }
      return 3;
    },
  },
});
